<thead class="table-head">
  <tr class="table-head-row --withHeaderData" *ngIf="header && header.length !== 0" (doubleClick)="toggleHeaderCheckBox()">
    <sp-table-head-cell *ngIf="withCheckbox">
      <sp-controls type="checkbox" [checked]="headerCheck" (change)="onToggleHeaderCheckbox($event)"></sp-controls>
    </sp-table-head-cell>
    <ng-template ngFor let-headerCell [ngForOf]="header" let-index="index">
      <sp-table-head-cell class="table-head-cell" [width]="headerCell.width">
        <div class="table-head-cell-container" [title]="headerCell.title">
          <div class="table-head-cell-label" (click)="headerCell.action()">
            <sp-icon
              class="table-head-cell-icon currentcolor"
              *ngIf="headerCell.icon && headerCell.icon !== ''"
              [name]="headerCell.icon"
              type="solid"
              size="small"
            ></sp-icon>
            {{ headerCell.title }}
          </div>
          <button *ngIf="headerCell.sortable" class="table-head-cell-sort" (click)="setSort(headerCell)">
            <img class="table-head-cell-sort-icon" [src]="sortIcons[headerCell.sort]" />
          </button>
        </div>
        <div *ngIf="headerCell.searchable">
          <sp-input type="text" placeholder="search column" [(ngModel)]="query[headerCell.title]"></sp-input>
        </div>
      </sp-table-head-cell>
    </ng-template>
  </tr>
  <tr class="table-head-row --normal" *ngIf="!header || header.length === 0" (doubleClick)="toggleHeaderCheckBox()">
    <sp-table-head-cell *ngIf="withCheckbox">
      <sp-controls type="checkbox" [checked]="headerCheck" (change)="onToggleHeaderCheckbox($event)"></sp-controls>
    </sp-table-head-cell>
    <ng-content></ng-content>
  </tr>
</thead>
